import { registerTooltipElement } from './schu-tooltip';
import { addSiteListeners } from './site';
import { initNavMenuState } from './nav-menu-state';
import { addConsentListeners } from './consent-listener';
import { inlineSvgSprites } from './sprites.js';
import { initLivePreview } from './live-preview';
import { enableVideoHero } from './video-hero';
import { initHubspot } from './hubspot';
import { initGTM } from './gtm';
import { enablePostHog } from './posthog';
import { rIC } from './idle-callback';
import { loadSwiperWhenNeeded } from './swiper-loader';

// To ensure configurability here pass the GTM key and hubspot key in the query string to the script on load

// 1. Get the currently executing script tag
const currentScript = document.currentScript;

let hubspotKey,
  GTMKey,
  postHogKey,
  isProduction,
  previewKey,
  previewEnv,
  iconFile;

if (currentScript)
{
  // 2. Get the full URL from the src attribute
  const scriptUrl = currentScript.src;

  // 3. Extract and parse the query string parameters
  const urlObj = new URL(scriptUrl);
  const params = new URLSearchParams(urlObj.search);

  // 4. Read individual values using the .get() method
  hubspotKey = params.get('hs');
  GTMKey = params.get('gtm');
  previewKey = params.get('live');
  previewEnv = params.get('env');
  postHogKey = params.get('ph');
  isProduction = params.get('prd');
  iconFile = params.get('icf');
}

// Place code that affects user interactivity here as soon as DOM is ready
// DO NOT place heavy third party scripts here as it affects your GTMetrix score - badly
//  and also impacts initial user experience
document.addEventListener('DOMContentLoaded', function ()
{
  // Posthog initialization needs to  happen as soon as possible so that any startup scripting issues can be caught
  enablePostHog(postHogKey, isProduction);

  // This needs to happen right away as it enables the main navigation
  addSiteListeners();
  initNavMenuState();
  registerTooltipElement();

  rIC(
    () =>
    {
      enableVideoHero(); // Should be switched to web element which can then be lazy loaded only for home page
    },
    { timeout: 1000 },
  );

  // SVG sprites can load whenever able
  rIC(
    () =>
    {
      void inlineSvgSprites(iconFile);
    },
    { timeout: 3000 },
  );

  // Swiper is loaded (self-hosted, not bundled) the first time a swiper-container shows up,
  // whether it's present now or added to the page later
  loadSwiperWhenNeeded();
});

// Load event firest after critical rendering is complete
//  Place heavy third party or external scripts here to avoid them impacting the initial load and GTMetrix scores
window.addEventListener('load', () =>
{
  // Analytics is the performance killer -- hubspot and GTM need to happen separately but consent listeners
  //  should be in place first
  addConsentListeners();

  rIC(
    () =>
    {
      initHubspot(hubspotKey);
    },
    { timeout: 1000 },
  );

  rIC(
    () =>
    {
      initGTM(GTMKey);
    },
    { timeout: 1000 },
  );

  // Live preview likely needs moved out of here into a separate angular spa for proper support really.
  //  the CSR support needs to be developed which is needed for the account section overhaul later anyway
  //  IMPROVEMENT NEEDED
  rIC(() =>
  {
    initLivePreview(previewKey, previewEnv);
  });
});
